import React, { useEffect, useState } from 'react'
import Modal from '../Modal'
import ColorPicker from '../Pickers/ColorPicker'
import Radio from '../Radio'
import styles from './index.module.scss'

interface ProjectDuplicateModalProps {
    isOpen: boolean
    defaultName: string
    defaultColor?: string
    onClose: () => void
    onConfirm: (data: { name: string, color: string, copyContent: boolean }) => Promise<void> | void
}

export default function ProjectDuplicateModal({
    isOpen,
    defaultName,
    defaultColor = '#FF5B5D',
    onClose,
    onConfirm,
}: ProjectDuplicateModalProps) {
    const [name, setName] = useState(defaultName)
    const [color, setColor] = useState(defaultColor)
    const [copyContent, setCopyContent] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        if (isOpen) {
            setName(defaultName)
            setColor(defaultColor)
            setCopyContent(true)
        }
    }, [defaultColor, defaultName, isOpen])

    const handleConfirm = async () => {
        if (!name.trim()) return

        setIsSubmitting(true)
        try {
            await onConfirm({
                name: name.trim(),
                color,
                copyContent,
            })
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleClose = () => {
        if (!isSubmitting) {
            onClose()
        }
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={handleClose} width={446}>
            <div className={styles.duplicateModal}>
                <div className={styles.duplicateModalClose} onClick={handleClose}>
                    <img src="/icon/closeCircle.svg" alt="close" />
                </div>

                <div className={styles.duplicateModalTitle}>Дублировать проект</div>

                <div className={styles.duplicateModalTop}>
                    <div className={styles.duplicateModalIconPlate}>
                        <div className={styles.duplicateModalLabel}>Значок</div>
                        <ColorPicker getColor={setColor} currentColor={color} />
                    </div>
                    <div className={styles.duplicateModalNamePlate}>
                        <div className={styles.duplicateModalLabel}>Название</div>
                        <input
                            className={`${styles.duplicateModalInput} ${name.trim() ? styles.duplicateModalInputActive : ''}`}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleConfirm()
                                if (e.key === 'Escape') handleClose()
                            }}
                            placeholder="Название проекта"
                            autoFocus
                        />
                    </div>
                </div>

                <div className={styles.duplicateModalCopy}>
                    <div>
                        <div className={styles.duplicateModalSubtitle}>Копировать все содержимое</div>
                        <div className={styles.duplicateModalDescription}>
                            Все свойства, задачи, наполнение, настройки будут полностью скопированы, если этот пункт активирован
                        </div>
                    </div>
                    <Radio changeState={setCopyContent} isOn={copyContent} />
                </div>

                <div className={styles.duplicateModalActions}>
                    <button className={styles.duplicateModalCancel} onClick={handleClose} disabled={isSubmitting}>
                        Отменить
                    </button>
                    <button className={styles.duplicateModalSubmit} onClick={handleConfirm} disabled={isSubmitting || !name.trim()}>
                        Дублировать
                    </button>
                </div>
            </div>
        </Modal>
    )
}
